import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { TimerComponent } from '../../../../sharedLegacy/components'
import { parseUTCUnixSecondsTime } from '../../../../sharedLegacy/utils'

import './LiveTimersComponent.scss'

const renderStreamingTime = (liveInfo, showStreaming, showIdle) => {
  if (!showStreaming) {
    return null
  }

  if (liveInfo.streaming_p === 1) {
    const duration = parseUTCUnixSecondsTime(liveInfo.streaming_start_time)

    return (
      <div className="streaming-time">
        <FormattedMessage defaultMessage="Streaming" />
        <TimerComponent seconds={duration} />
      </div>
    )
  }

  if (showIdle) {
    return (
      <div className="streaming-time idle">
        <FormattedMessage defaultMessage="Not streaming" />
      </div>
    )
  }

  return null
}

const renderRecordingTime = (liveInfo, showRecording, showIdle) => {
  if (!showRecording) {
    return null
  }

  if (liveInfo.recording_p === 1) {
    const duration = parseUTCUnixSecondsTime(liveInfo.recording_start_time)

    return (
      <div className="recording-time">
        <FormattedMessage defaultMessage="Rec" description="Recording" />
        <TimerComponent seconds={duration} />
      </div>
    )
  }

  if (showIdle) {
    return (
      <div className="recording-time idle">
        <FormattedMessage defaultMessage="Not recording" />
      </div>
    )
  }

  return null
}

const renderBroadcastingTime = (liveInfo, showBroadcasting, showIdle) => {
  if (!showBroadcasting) {
    return null
  }

  if (liveInfo.broadcasting_p === 1) {
    const startTime =
      liveInfo.broadcasting_start_time_epoch || liveInfo.broadcasting_start_time
    const duration = parseUTCUnixSecondsTime(startTime)

    return (
      <div className="broadcasting-time">
        <FormattedMessage defaultMessage="Live" />
        <TimerComponent seconds={duration} />
      </div>
    )
  }

  if (showIdle) {
    return (
      <div className="broadcasting-time idle">
        <FormattedMessage defaultMessage="Not live" />
      </div>
    )
  }

  return null
}

const LiveTimersComponent = (props) => {
  const {
    liveInfo,
    showBroadcasting,
    showRecording,
    showStreaming,
    showIdle,
    noButtonStyles,
  } = props

  return (
    <div
      className={classnames('live-timers-component', {
        'no-button-styles': noButtonStyles,
      })}
    >
      {renderStreamingTime(liveInfo, showStreaming, showIdle)}
      {renderRecordingTime(liveInfo, showRecording, showIdle)}
      {renderBroadcastingTime(liveInfo, showBroadcasting, showIdle)}
    </div>
  )
}

LiveTimersComponent.propTypes = {
  liveInfo: PropTypes.object,
  showStreaming: PropTypes.bool,
  showBroadcasting: PropTypes.bool,
  showRecording: PropTypes.bool,
  showIdle: PropTypes.bool,
  noButtonStyles: PropTypes.bool,
}

LiveTimersComponent.defaultProps = {
  showStreaming: true,
  showBroadcasting: true,
  showRecording: true,
  noButtonStyles: false,
}

export { LiveTimersComponent }
